import { motion } from "framer-motion";
import { IMG } from "../data/site";

export const About = () => (
  <section id="about" data-testid="about-section" className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-32 scroll-mt-16">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center">
      <motion.div
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="md:col-span-5"
      >
        <div className="relative">
          <div className="overflow-hidden rounded-lg aspect-[4/5]">
            <img src={IMG.portrait} alt="Arnav" loading="lazy" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-4 -right-4 bg-[#FFB6C1] rounded-lg px-5 py-3 font-display font-black text-lg tracking-tight">
            5+ yrs, 60+ brands
          </div>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.15 }}
        className="md:col-span-7"
      >
        <p className="font-display text-xs uppercase tracking-[0.3em] font-semibold text-[#0047FF] mb-4">About</p>
        <h2 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-[1.02] mb-8">
          Hi, I'm Arnav<span className="text-[#0047FF]">.</span>
        </h2>
        <p className="text-base md:text-lg text-black/60 leading-relaxed max-w-xl">
          I'm a one-person creative studio. No account managers, no handoffs. You talk directly to the person doing the work.
        </p>
        <p className="text-base md:text-lg text-black/60 leading-relaxed max-w-xl mt-5">
          I mix classic brand craft with new tools like AI visuals, fast video and sharp SEO, so small teams get big-agency output at freelancer speed.
        </p>
        <div className="mt-10 flex flex-wrap gap-x-10 gap-y-6">
          {[["60+", "brands helped"], ["9", "services under one roof"], ["<24h", "reply time"]].map(([n, l]) => (
            <div key={l}>
              <p className="font-display font-black text-3xl md:text-4xl tracking-tighter">{n}</p>
              <p className="text-xs uppercase tracking-widest font-semibold text-black/40 mt-1">{l}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
